import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const JournalsIntelligenceContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="h6" component="h2">
        {t('journalsIntelligence.quality')}
      </Typography>
    </div>
  );
};
